export function toEnglishNumber(strNum = "") {
  var ar = "٠١٢٣٤٥٦٧٨٩".split("");
  var en = "0123456789".split("");
  strNum = strNum.toString().replace(/[٠١٢٣٤٥٦٧٨٩]/g, (x) => en[ar.indexOf(x)]);
  // strNum = strNum.replace(/[^\d]/g, "");
  return strNum;
}

export function calculateAge(dateOfBirth) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  if (m < 0) {
    m = m + 12;
  }
  // return age;
  // console.log("the age, months", age, m);
  return [age, m];
}

export function calculateTotalPrice(services, servicePrices) {
  let totalPrice = 0;
  Object.entries(services).forEach(([serviceName, isSelected]) => {
    if (isSelected) {
      if (serviceName === "Unpaid") {
        totalPrice -= servicePrices[serviceName];
      } else {
        totalPrice += servicePrices[serviceName];
      }
    }
  });
  return totalPrice;
}

export function calculateTotalPriceAll(services, servicePrices) {
  let totalPrice = 0;
  Object.entries(services).forEach(([serviceName, isSelected]) => {
    if (isSelected) {
      if (serviceName !== "Unpaid") {
        totalPrice += servicePrices[serviceName];
      }
    }
  });
  return totalPrice;
}

export function formatTime(timeLanguage, timeStr) {
  // timeLanguage for example "ar-EG" or "en-US"
  // Split the time string into hours and minutes
  const [hoursStr, minutesStr] = timeStr.split(":");

  // Extract the hours and minutes as numbers
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  // Adjust the hours for PM times
  if (timeStr.indexOf("pm") !== -1 && hours < 12) {
    hours += 12;
  }

  // Create a new Date object with the adjusted hours and minutes
  const time = new Date();
  time.setHours(hours);
  time.setMinutes(minutes);

  // Format the time string using toLocaleTimeString()
  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  return time.toLocaleTimeString(timeLanguage, options);
}

// export function formatDate(dateLanguage, dateString) {
//   // dateLanguage for example "ar-EG" or "en-US"

//   const date = new Date(dateString);
//   const options = {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   };
//   return date.toLocaleDateString(dateLanguage, options);
// }

export function formatDate(dateLanguage, dateString) {
  const date = new Date(dateString);
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formatter = new Intl.DateTimeFormat(dateLanguage, options);
  return formatter.format(date);
}

export function convertTimeTo24HourFormat(timeString) {
  const [time, period] = timeString.split(" ");
  let [hours, minutes] = time.split(":");
  if (period === "pm") {
    hours = parseInt(hours, 10) + 12;
  }
  hours = hours.toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

export function editObject(
  docId,
  timeSlot,
  ptMedRNToEdit,
  newObjectProperties
) {
  console.log(
    "editObject",
    docId,
    timeSlot,
    ptMedRNToEdit,
    newObjectProperties
  );
}
